import type { OutcomeParameterName } from '../../../types';
import type { Filter, FiltersByOutcomeParameterMap } from '../types';

export const createFiltersByOutcomeParameterMap = (): FiltersByOutcomeParameterMap => {
    return new Map<OutcomeParameterName, Filter>();
}
